
import router from "@/router";
import { mapGetters, mapMutations } from "vuex";
import mixins from "vue-typed-mixins";
import Common from "@/mixins/Common";
import store from "@/store";
import { TwoFactorTypeEnum } from "@/interfaces/TwoFactorTypeEnum";
import TwoFactorComponent from "@/components/TwoFactorComponent.vue";
import { number, object, string, boolean } from "yup";
import swal from "sweetalert";
import Vue from "vue";
import Password from "primevue/password";
import LottieAnimation from "@/components/LottieAnimationsComponent.vue";
import confetti from "canvas-confetti";

enum welcomeFlow {
  verifyPayment = 0,
  paymentSuccess = 1,
  codeVerification = 2,
  createPassword = 3,
}

export default mixins(Common).extend({
  mixins: [Common],
  props: {
    email: { type: String, default: null },
    phone: { type: String, default: null },
    sku: { type: String, default: null },
    orderid: { type: String, default: null },
  },
  data() {
    return {
      cpass: null as string | null,
      newpass: null as string | null,
      screen: 0,
      bus: new Vue(),
      questionnaireTypeID: null as null | number,
      token: "",
      authMethod: 2 as TwoFactorTypeEnum | 0,
      authMethods: [2, 3] as TwoFactorTypeEnum[] | [],
      schemaReset: object().shape({
        pass: string().typeError("Password is required.").required("Password is required."),
        newpass: string().typeError("Password is required.").required("Password is required."),
        cpass: string().typeError("Password is required.").required("Password is required."),
      }),
      showPasswd: false,
      enableSubmit: false,
      enableChangePassword: true,
      validated: false,
      error: "" as string | "",
      eightChars: false,
      oneNumber: false,
      lowerCase: false,
      upperCase: false,
      match: null as boolean | null,
      numberOfRefillsRemaining: 0,
      isSamCart: false,
    };
  },
  computed: {
    ...mapGetters({
      Content: "getContent",
      Lang: "getLang",
    }),
  },
  async mounted() {
    this.setLoading(true);
    this.getUTM();
    this.getPromoCode();
    await this.waitForSamCartWH();
    const path = window.location.pathname;
    console.log("Current path:", path);
    if (path.includes("/gosamcart")) {
      this.isSamCart = true;
    }
    console.log("isSam set to:", this.isSamCart);
  },
  watch: {
    newpass: function () {
      this.validatePassword();
    },
    cpass: function () {
      this.validatePassword();
    },
  },
  methods: {
    ...mapMutations({
      setLoading: "setLoading",
      setCurrentQuestType: "setCurrentQuestType",
      setCurrentRefillNum: "setCurrentRefillNum",
    }),
    validatePassword: function () {
      this.enableSubmit = false;

      if (this.newpass && this.newpass.length > 7) {
        this.eightChars = true;
      } else {
        this.eightChars = false;
      }
      var rgxON = RegExp("[0-9]");
      if (this.newpass && rgxON.test(this.newpass)) {
        this.oneNumber = true;
      } else {
        this.oneNumber = false;
      }
      var lcRGX = RegExp("[a-z]");
      if (this.newpass && lcRGX.test(this.newpass)) {
        this.lowerCase = true;
      } else {
        this.lowerCase = false;
      }
      var ucRGX = RegExp("[A-Z]");
      if (this.newpass && ucRGX.test(this.newpass)) {
        this.upperCase = true;
      } else {
        this.upperCase = false;
      }
      if (this.cpass && this.newpass == this.cpass) {
        this.match = true;
      } else {
        this.match = false;
      }

      if (this.eightChars && this.oneNumber && this.lowerCase && this.upperCase && this.match) {
        this.enableSubmit = true;
      }
    },
    async btnchangePassword(e: Event) {
      if (e) e.preventDefault();
      const resp = await store.dispatch("UserPasswordChange", { p: this.cpass, np: this.newpass, c: "", m: 0 });
      if (!resp.data && resp.errors && resp.errors.length > 0) {
        if (!(resp.errors[0] == "Invalid two factor code")) {
          // this.view = screenview.passChange;
        }
        swal(resp.errors[0]);
        return;
      }
      //this.view = screenview.defaultView;
      this.OpenQuestionnaire(this.questionnaireTypeID);
    },
    resetChangePass() {
      this.cpass = null;
      this.newpass = null;
    },
    continueToCode() {
      this.screen = welcomeFlow.codeVerification;
    },
    async onSubmitMFA(code: string, method: TwoFactorTypeEnum) {
      this.setLoading(true);
      const response = await store.dispatch("AuthTwoFactorOnly", { method: method, c: code, email: this.email, phone: this.phone });
      this.setLoading(false);
      if (response == null) {
        //token expired
        swal("Sign in failed!", "Invalid auth token", "error");
        return;
      }
      if (!response) {
        swal("Sign in failed!", "Invalid code", "error");
        return;
      }

      if (response.forcePasswordReset) {
        this.screen = 3;
      } else {
        this.OpenQuestionnaire(this.questionnaireTypeID);
      }
    },
    OpenQuestionnaire(t: number) {
      this.setCurrentQuestType(t);
      if (this.numberOfRefillsRemaining) {
        this.setCurrentRefillNum(this.numberOfRefillsRemaining);
        router.push(`/refill`);
      } else {
        router.push({ path: "/questionnaire" });
      }
    },
    async waitForSamCartWH() {
      const result = await store.dispatch("GetSamCartQuestionnaire", { sku: this.sku, email: this.email, orderid: this.orderid });
      if (result?.data?.success) {
        console.log(result?.data?.success);
        this.questionnaireTypeID = parseInt(result?.data.data.item1);
        this.numberOfRefillsRemaining = result?.data.data.item2;
        // send code
        this.bus.$emit("send2fa");
        this.screen = 1;
        confetti({
          particleCount: 100,
          spread: 70,
          origin: { y: 0.6 },
        });
      } else {
        setTimeout(async () => {
          await this.waitForSamCartWH();
        }, 3000);
      }
    },
  },
  components: {
    TwoFactorComponent,
    Password,
    LottieAnimation,
  },
});
